import Delegate from "ftdomdelegate";

export default class VariantSelector {
  constructor(element) {
    var options =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    this.element = element;
    this.delegateElement = new Delegate(this.element);

    this.activator =
      options["activator"] ||
      document.querySelector(
        '[aria-controls="' + element.getAttribute("id") + '"]'
      );
    this.onValueChangedCallback = options["onValueChanged"] || function () {};
    this.isOpen = false;

    this.pageOverlayElement = document.querySelector(".pageOverlay");

    this.variantChoiceList = Dom.nodeListToArray(
      this.element.querySelectorAll(".variantSelector__choice")
    );
    this.variantCarousel = new Carousel(
      this.element.querySelector(".variantSelector__carousel"),
      {
        onSelect: this._variantChanged.bind(this),
        onClick: this._variantSelected.bind(this)
      }
    );

    this._attachListeners();
  }

  destroy() {
    this.element.removeEventListener("keyup", this._handleKeyboardListener);
    this.delegateElement.off("click");
    this.activator.removeEventListener("click", this._toggleListener);
    this.variantCarousel.destroy();
  }

  toggle() {
    this.isOpen ? this.close() : this.open();
  }

  open() {
    if (this.isOpen) {
      return;
    }

    this.element.setAttribute("aria-hidden", "false");
    this.activator.setAttribute("aria-expanded", "true");

    Accessibility.trapFocus(this.element, "variant-selector");

    document.documentElement.classList.add("no-scroll"); // Prevent scrolling when popover is open

    this.element.setAttribute("style", "");
    this.pageOverlayElement.classList.add("is-visible");
    this.pageOverlayElement.addEventListener("click", this._closeListener);

    this.isOpen = true;
  }

  close() {
    if (!this.isOpen) {
      return;
    }

    this.element.setAttribute("aria-hidden", "true");
    this.activator.setAttribute("aria-expanded", "false");

    Accessibility.removeTrapFocus(this.element, "variant-selector");

    document.documentElement.classList.remove("no-scroll");

    this.pageOverlayElement.classList.remove("is-visible");
    this.pageOverlayElement.removeEventListener("click", this._closeListener);

    this.isOpen = false;
  }

  _attachListeners() {
    this._handleKeyboardListener = this._handleKeyboard.bind(this);
    this._closeListener = this.close.bind(this);
    this._toggleListener = this.toggle.bind(this);

    this.element.addEventListener("keyup", this._handleKeyboardListener);
    this.activator.addEventListener("click", this._toggleListener);
    this.delegateElement.on(
      "click",
      '[data-action="select-variant"]',
      this._onVariantSelect.bind(this)
    );
  }

  /**
   * Called when the variant is changed (but not yet selected)
   */

  _variantChanged(selectedIndex) {
    var activeChoice = this.variantChoiceList[selectedIndex];

    activeChoice.classList.add("is-selected");
    Dom.getSiblings(activeChoice, ".is-selected").forEach(function (item) {
      return item.classList.remove("is-selected");
    });
  }

  /**
   * Called when a variant is clicked or selected
   */

  _variantSelected(cellElement, cellIndex) {
    if (this.variantCarousel.getSelectedIndex() === cellIndex) {
      this.onValueChangedCallback(
        cellElement.getAttribute("data-option-value"),
        cellElement,
        this.activator
      );
      this.close();
    } else {
      this.variantCarousel.selectCell(cellIndex);
    }
  }

  /**
   * Called when the button "choose this variant" is explicitly clicked
   */

  _onVariantSelect() {
    var selectedCell =
      this.variantCarousel.flickityInstance.selectedCell.element;

    this.onValueChangedCallback(
      selectedCell.getAttribute("data-option-value"),
      selectedCell,
      this.activator
    );
    this.close();
  }

  /**
   * Handle a11y events
   */

  _handleKeyboard(event) {
    if (this.isOpen && event.keyCode === 27) {
      this.close();
    }
  }
}
